

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import AlbumDisplay from '@/components/galleries/AlbumDisplay.vue';
import AlbumFilters from '@/components/filters/AlbumFilters.vue';
import LoadingAnimation from '@/components/loading/LoadingAnimation.vue';
import { Album } from '@/store/albums/types';

@Component({
    components: {
        AlbumDisplay,
        AlbumFilters,
        LoadingAnimation,
    },
})
export default class AlbumGallery extends Vue {
    @Prop()
    albums!: Album[];
}

